module.exports = __webpack_public_path__ + "img/img_server_notice.0f938d23.png";